import React, { useState } from "react";
import { exportDateRangeDoc } from "../../api/api";
import "./AdminPanel.css";

function DatabaseExportAdminPanel() {
  const [exportRange, setExportRange] = useState({ startDate: "", endDate: "" });
  const [isExporting, setIsExporting] = useState(false);
  const [notification, setNotification] = useState(null);
  const token = localStorage.getItem("token");
  const role = localStorage.getItem('role');

  const showNotification = (message, type = "success") => {
    setNotification({ message, type });
    setTimeout(() => setNotification(null), 4000);
  };

  const handleExportDateRange = async (e) => {
    e.preventDefault();
    if (!exportRange.startDate || !exportRange.endDate) {
      alert("Please select both start date and end date.");
      return;
    }
    if (exportRange.startDate > exportRange.endDate) {
      alert("Start date cannot be greater than end date.");
      return;
    }
    setIsExporting(true);
    try {
      const response = await exportDateRangeDoc(exportRange.startDate, exportRange.endDate);
      const fileUrl = window.URL.createObjectURL(new Blob([response.data], { type: "application/msword" }));
      const link = document.createElement("a");
      link.href = fileUrl;
      link.download = `status-study-export-${exportRange.startDate}-to-${exportRange.endDate}.doc`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(fileUrl);
      showNotification("Date range export document downloaded successfully.", "success");
    } catch (err) {
      const errorMsg = err.response?.data?.error || err.message || "Unable to export document";
      alert(`Error: ${errorMsg}`);
      showNotification(errorMsg, "error");
    } finally {
      setIsExporting(false);
    }
  };

  if (!token) {
    return (
      <div style={{ padding: "20px", color: "red", fontSize: "18px" }}>
        ❌ No token found! Please login first.
      </div>
    );
  }

  if (role !== 'superadmin') {
    return <div style={{ color: 'red', textAlign: 'center', marginTop: '2rem' }}>Access denied: Superadmin only</div>;
  }

  return (
    <div className="admin-panel">
      {notification && (
        <div className={`notification notification-${notification.type}`}>
          {notification.message}
        </div>
      )}
      <div className="admin-export-panel">
        <h2>Database Export Panel</h2>
        <p>Choose a start date and end date, then download all matching database records in a DOC file.</p>
        <form className="admin-export-form" onSubmit={handleExportDateRange}>
          <div className="admin-export-field">
            <label htmlFor="export-start-date">Date 1</label>
            <input
              id="export-start-date"
              type="date"
              value={exportRange.startDate}
              onChange={(e) => setExportRange((current) => ({ ...current, startDate: e.target.value }))}
              required
            />
          </div>
          <div className="admin-export-field">
            <label htmlFor="export-end-date">Date 2</label>
            <input
              id="export-end-date"
              type="date"
              value={exportRange.endDate}
              onChange={(e) => setExportRange((current) => ({ ...current, endDate: e.target.value }))}
              required
            />
          </div>
          <button type="submit" className="admin-export-button" disabled={isExporting}>
            {isExporting ? "Preparing DOC..." : "Download DOC Export"}
          </button>
        </form>
      </div>
    </div>
  );
}

export default DatabaseExportAdminPanel;
